var modules_648c7803 = {"container":"_1lrpd5b"};
import "../../../assets/C1ROwcYK.css";

export { modules_648c7803 as default };
//# sourceMappingURL=Thead.module.less.js.map
